import React from "react";

const BASE = process.env.REACT_APP_BACKEND_URL;

// Cattura qualsiasi errore di rendering React: invece di lasciare lo schermo nero
// (albero smontato), mostra una schermata leggibile con pulsante "Ricarica" e
// invia un beacon diagnostico al backend per registrare lo stack reale.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Errore sconosciuto" };
  }

  componentDidCatch(error, info) {
    try {
      // eslint-disable-next-line no-console
      console.error("[ErrorBoundary]", error, info);
      const payload = {
        message: error?.message || String(error),
        stack: (error?.stack || "").slice(0, 4000),
        component_stack: (info?.componentStack || "").slice(0, 4000),
        url: window.location.href,
        user_agent: navigator.userAgent,
      };
      if (BASE && navigator.sendBeacon) {
        const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
        navigator.sendBeacon(`${BASE}/api/client-errors`, blob);
      } else if (BASE) {
        fetch(`${BASE}/api/client-errors`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
          keepalive: true,
        }).catch(() => {});
      }
    } catch {
      /* il boundary non deve mai a sua volta lanciare */
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="app-error-boundary"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0b0f14",
          color: "#e8eef5",
          fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
          padding: "24px",
        }}
      >
        <div style={{ maxWidth: 420, textAlign: "center" }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>⚠️</div>
          <h1 style={{ fontSize: 20, fontWeight: 600, margin: "0 0 8px" }}>
            Si è verificato un problema
          </h1>
          <p style={{ fontSize: 14, lineHeight: 1.5, opacity: 0.75, margin: "0 0 20px" }}>
            La pagina non è riuscita a caricarsi correttamente. Ricarica per riprovare.
            Se il problema continua, contatta il tuo referente.
          </p>
          <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
            <button
              data-testid="error-reload-btn"
              onClick={() => window.location.reload()}
              style={{
                background: "#3b82f6",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "10px 18px",
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Ricarica la pagina
            </button>
            <button
              data-testid="error-login-btn"
              onClick={() => {
                try {
                  // Reset completo dei dati salvati in locale: una voce residua o
                  // non valida è la causa più comune di un errore che si ripete
                  // solo su un browser specifico.
                  localStorage.clear();
                  sessionStorage.clear();
                } catch { /* noop */ }
                window.location.href = "/login";
              }}
              style={{
                background: "transparent",
                color: "#e8eef5",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: 8,
                padding: "10px 18px",
                fontSize: 14,
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Torna al login
            </button>
          </div>
          <p style={{ fontSize: 12, lineHeight: 1.5, opacity: 0.55, margin: "16px 0 0" }}>
            "Torna al login" azzera i dati salvati su questo browser: nella maggior parte dei casi risolve.
          </p>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
